import React, { Component } from 'react';

import "./styles.css";

export default function MapProjectView(props) {

  const viewProject = (projectSlug) => {
    if (window.win_language_code !== 'en') {
      let redirect_url = '/' + window.win_language_code + '/projects/' + projectSlug
      window.location.href = redirect_url
    } else {
      window.location.href = /projects/ + projectSlug;
    }

  }

  const projectLink = () => {
    if (window.win_language_code !== 'en') {
      return '/' + window.win_language_code + '/projects/' + props.project.projectSlug
    } else {
      return '/projects/' + props.project.projectSlug;
    }

  }

  const profileLink = () => {
    if (window.win_language_code !== 'en') {
      return '/' + window.win_language_code + props.hit.directory_link
    }
    return props.hit.directory_link
  }

  if (props) {

    if (props.project) {

    return (
      <div className={`project project--view project--inline`}>
        <div onClick={() => viewProject(props.project.projectSlug)} className="project__image" style={{backgroundImage: 'url(' + props.project.projectImage + ')'}}></div>
        <div onClick={() => viewProject(props.project.projectSlug)} className="project__content">
          <div className="project__content-head">
            <div className="project__content-head-inner">
              <h4 className="project__title">
                <a href={projectLink()}>
                {props.project.projectName}
                </a>
              </h4>
              <span className="project__location">
                <span>{props.project.category}</span>
              </span>
            </div>
          </div>
        </div>
        <div className="project__close">
          <a href="/projects" onClick={event => {
            event.preventDefault();
            let el = document.getElementById('marker-item-' + props.project.id);
            if (el) {
              let img = el.dataset.img;
              el.src = img;
            }
            props.project.handleProjectViewClose(null);
          }}>
          <i className="ico-close">
            <svg>
              <use xlinkHref="#ico-close"></use>
            </svg>
          </i>
          </a>
        </div>
      </div>
    );
  }
}
return null
}
